import * as ActionTypes from "constants/ActionTypes";

function windowIsBlurred(state = false, action) {
  switch (action.type) {
    case ActionTypes.WINDOW_BLUR:
      return true;
    case ActionTypes.WINDOW_FOCUS:
      return false;
    default:
      return state;
  }
}

// We don't use `combineReducers` because this is the only one
export default windowIsBlurred;
